import { Box } from '@material-ui/core';
import { object } from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import React from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { makeStyles } from '@material-ui/core/styles';
import MarkerIcon from './location.svg';
import TimeIcon from './time.svg';

const containerStyle = {
  width: '100%',
  height: '210px',
};

const useStyles = makeStyles({
  icon: {
    marginRight: 23,
  },
  info: {
    margin: '10px 0',
    fontSize: 14,
    lineHeight: '22px',
  },
  infoText: {
    fontSize: 14,
    lineHeight: '22px',
  },
  name: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
    fontFamily: 'MadaBold',
    color: '#01619B',
  },
  distance: {
    color: '#EA6810',
    fontSize: 14,
    fontFamily: 'MadaBold',
    marginLeft: 7,
  },
});

const LocationCard = ({ data }) => {
  const {
    fields: {
      postalCode = '',
      state = '',
      streetAddress = '',
      hours,
      city = '',
      distance,
    },
    fields,
  } = data;

  const classes = useStyles();
  const address = `${streetAddress} ${city}, ${state} ${postalCode}`;
  const center = {
    lat: _get(fields, 'location.lat'),
    lng: _get(fields, 'location.lon'),
  };
  const timeInfo = hours ? hours.split('/') : null;
  const handleMarkerClick = () => {
    window.open(
      `http://www.google.com/maps/place/${center.lat},${center.lng}`,
      '_blank',
    );
  };
  return (
    <Box display="flex" flexDirection="column">
      <div>
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
          <Marker
            position={center}
            title={address}
            onClick={handleMarkerClick}
          />
        </GoogleMap>
      </div>
      <div className={classes.name}>
        <span className={classes.title}> {_get(fields, 'title')}</span>

        {distance ? (
          <span className={classes.distance}>{distance} MILES</span>
        ) : null}
      </div>
      <Box display="flex" className={classes.info}>
        <div>
          <img src={MarkerIcon} alt="address" className={classes.icon} />
        </div>
        <div>{address}</div>
      </Box>
      {!_isEmpty(timeInfo) && (
        <Box display="flex" className={classes.info}>
          <div>
            <img src={TimeIcon} alt="Time" className={classes.icon} />
          </div>
          <div>
            <Box>
              <div className={classes.infoText}> {_get(timeInfo, '0')}</div>
              <div lassName={classes.infoText}> {_get(timeInfo, '1')}</div>
            </Box>
          </div>
        </Box>
      )}
    </Box>
  );
};

LocationCard.propTypes = {
  data: object,
};

export default LocationCard;
